const editorialCarousel = () => {
    const editorialCarousels = document.querySelectorAll('[data-editorial-carousel]');
    editorialCarousels.forEach((carousel) => {
        let i = 0;
        const autoPlay = carousel.getAttribute('data-editorial-carousel-autoplay');
        const duration = parseInt(carousel.getAttribute('data-editorial-carousel-duration'));
        const slides = carousel.querySelectorAll('[data-editorial-carousel-slide]');
        const navLinks = carousel.querySelectorAll('[data-editorial-carousel-nav]');
        const updateSlideClasses = (slide, nav) => {
            navLinks.forEach((link) => {
                link.classList.remove('navigation__item--active');
            });
            slides.forEach((slide) => {
                slide.classList.remove('editorial-carousel__slide--active');
            });
            slide.classList.add('editorial-carousel__slide--active');
            nav.classList.add('navigation__item--active');
        };
        if (autoPlay == 'true') {
            setInterval(() => {
                if (!carousel.classList.contains('editorial-carousel__inner--pause')) {
                    if (i < slides.length - 1) {
                        i++;
                        updateSlideClasses(slides[i], navLinks[i]);
                    }
                    else {
                        i = 0;
                        updateSlideClasses(slides[0], navLinks[0]);
                    }
                }
            }, duration);
        }
        slides.forEach((slide) => {
            const video = slide.querySelector('video');
            if (video) {
                const config = { attributes: true };
                const callback = () => {
                    if (slide.classList.contains('editorial-carousel__slide--active')) {
                        video.play();
                    }
                    else {
                        video.pause();
                    }
                };
                const observer = new MutationObserver(callback);
                observer.observe(slide, config);
            }
        });
        navLinks.forEach((link) => {
            link.addEventListener('click', () => {
                const target = link.getAttribute('data-editorial-carouse-target');
                i = parseInt(target);
                navLinks.forEach((link) => {
                    link.classList.remove('navigation__item--active');
                });
                slides.forEach((slide) => {
                    slide.classList.remove('editorial-carousel__slide--active');
                });
                link.classList.add('navigation__item--active');
                slides[target].classList.add('editorial-carousel__slide--active');
            });
        });
        carousel.addEventListener('mouseover', () => {
            carousel.classList.add('editorial-carousel__inner--pause');
        });
        carousel.addEventListener('mouseout', () => {
            carousel.classList.remove('editorial-carousel__inner--pause');
        });
    });
};
export { editorialCarousel };
